import React from "react";
import {t} from "../../../I18n/i18n"

const DrugsReport = ({drugs}) => {
    if(drugs === null || drugs.length === 0) return null
    return (
        <p>
            <span style={{fontWeight: "bold"}}>{t("DRUGS")} : </span>
            {drugs.map((drug, index) => (
                <span className="chip" key={index}>{drug.label}</span>
            ))}
        </p>
    )
}
export default DrugsReport;